import { AssessmentActionPlanItem } from "./assessment-action-plan-item";
import { ProjectPart } from "./project-part";

export class AssessmentActionPlan extends ProjectPart {
  improvementPlanStatusID: number = 0;
  name: string = "";
  description: string = "";
  dueDate: string = "";
  budgetAllocationDescription: string = "";
  budgetAllocationAmount: string = "";
  actionItemList: AssessmentActionPlanItem[] = [];


  fieldsDisabled: boolean = false;
  descriptionDisabled: boolean = false;
  dueDateDisabled: boolean = false;
  budgetAllocationDescriptionDisabled: boolean = false;
  budgetAllocationAmountDisabled: boolean = false;
  statusDisabled: boolean = false;

  constructor(
    prefix: string = "",
    id: number = 0,
    requestKey: string = "",
    improvementPlanStatusID: number = 0,
    name: string = "",
    description: string = "",
    dueDate: string = "",
    budgetAllocationDescription: string = "",
    budgetAllocationAmount: string = "",
    actionItemList: AssessmentActionPlanItem[] = [],
    fieldsDisabled: boolean = false,
    descriptionDisabled: boolean = false,
    dueDateDisabled: boolean = false,
    budgetAllocationDescriptionDisabled: boolean = false,
    budgetAllocationAmountDisabled: boolean = false,
    statusDisabled: boolean = false,
    expanded: boolean = true
  ) {
    super("actionPlan", id, requestKey, expanded, prefix);
    this.improvementPlanStatusID = improvementPlanStatusID;
    this.name = name;
    this.description = description;
    this.dueDate = dueDate;
    this.budgetAllocationDescription = budgetAllocationDescription;
    this.budgetAllocationAmount = budgetAllocationAmount;
    this.actionItemList = actionItemList;

    this.fieldsDisabled = fieldsDisabled;
    this.descriptionDisabled = descriptionDisabled;
    this.dueDateDisabled = dueDateDisabled;
    this.budgetAllocationAmountDisabled = budgetAllocationAmountDisabled;
    this.budgetAllocationDescriptionDisabled = budgetAllocationDescriptionDisabled;
    this.statusDisabled = statusDisabled;
  }
}
